// extracted by mini-css-extract-plugin
module.exports = {"shareBox":"_3leNBUCk12IO7XNzNXGymU"};